<template>
    <van-nav-bar title="Apertura de cuenta exitosa" fixed left-arrow @click-left="onClickLeft" placeholder />
    <div class="page">
        <p class="title">Felicidades<br />Apertura de cuenta exitosa</p>
        <img class="imgcgkh" src="@/assets/images/imgcgkh.png" alt="">
        <p class="ps">Descargar APP <span class="blue">Reclamar bono de prueba</span></p>
        <div class="list">
            <div class="item">
                <a class="img" href="https://play.google.com/store/apps/details?id=com.rdberntn.tnvmhyryn"
                    target="_blank">
                    <img src="@/assets/images/logos-para-web-legales_Disponible-en-Google-Play-Negro.png" alt="">
                </a>
                <a class="btn" href="https://play.google.com/store/apps/details?id=com.rdberntn.tnvmhyryn"
                    target="_blank">
                    <img src="@/assets/images/az.png" alt="">
                    <span>descargar</span>
                </a>
            </div>
            <div class="item">
                <a class="img" href="https://apps.apple.com/app/id6756229981" target="_blank">
                    <img src="@/assets/images/logos-para-web-legales_Disponible-en-App-Store-Blanco-300x89-1.png"
                        alt="">
                </a>
                <a class="btn" href="https://apps.apple.com/app/id6756229981" target="_blank">
                    <img src="@/assets/images/ios.png" alt="">
                    <span>descargar</span>
                </a>
            </div>
        </div>
    </div>

</template>
<script setup name="BullMarketBrokers">
const onClickLeft = () => history.back()
</script>
<style scoped lang="scss">
.page {
    padding: 30px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        text-align: center;
        color: #000;
        font-family: "Microsoft YaHei UI";
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .imgcgkh {
        width: 206px;
        margin-top: 32px;
        margin-bottom: 100px;
    }

    .ps {
        color: #000;
        font-family: "Microsoft YaHei UI";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: center;

        .blue {
            color: #5F8FF2;
            font-family: "Microsoft YaHei UI";
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }

    .list {
        display: flex;
        gap: 20px;
        margin-top: 26px;

        .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 19px;

            .img {
                width: 140px;

                img {
                    width: 100%;
                }
            }

            .btn {
                border-radius: 10px;
                background: #2969FF;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 3px;
                padding: 4px 12px;
                color: #FFF;
                font-family: "Microsoft YaHei UI";
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;

                img {
                    width: 28px;
                }
            }
        }
    }
}
</style>